import { http } from './http';
import { unwrapSuccess } from './helpers';

export async function listTransactions(accountId, page = 1, size = 20, filter = {}) {
    const res = await http.get(`accounts/${accountId}/transactions`, {
        params: { page, size, ...filter },
    });
    return unwrapSuccess(res);
}

export async function createTransaction(accountId, payload) {
    const res = await http.post(`accounts/${accountId}/transactions`, payload);
    return unwrapSuccess(res);
}

export async function updateTransaction(accountId, id, payload) {
    const res = await http.put(`accounts/${accountId}/transactions/${id}`, payload);
    return unwrapSuccess(res);
}

export async function deleteTransaction(accountId, id) {
    return http.delete(`accounts/${accountId}/transactions/${id}`);
}
